import { useEffect, useState } from "react";
import { useLenis } from "../../hooks/useLenis";
import { useSEO } from "../../hooks/useSEO";
import { api, resolveMediaUrl } from "../../lib/api";
import { Navbar } from "../layout/Navbar";
import { Footer } from "../layout/Footer";
import { WhatsAppFloat } from "../layout/WhatsAppFloat";
import { RevealSection } from "../motion/RevealSection";
import { PageHero } from "./PageHero";
import { HighlightsGrid } from "./HighlightsGrid";
import { FAQSection } from "./FAQSection";
import { RelatedLinks } from "./RelatedLinks";
import { PageCTA } from "./PageCTA";
import { SecondaryImagesGrid } from "./SecondaryImagesGrid";
import { ServiceVideoSection } from "./ServiceVideoSection";

export const ServiceLandingPage = ({ page }) => {
  useLenis();
  const [content, setContent] = useState(null);
  const [seo, setSeo] = useState(null);

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data));
    api.get(`/seo-pages/${page.pageId}`).then((r) => setSeo(r.data));
  }, [page.pageId]);

  useSEO({
    title: seo?.seo_title || "The Wedding Photographie",
    description: seo?.seo_description || "",
    path: page.slug,
  });

  const brandName = content?.hero_headline || "The Wedding Photographie";

  if (!seo) {
    return <div data-testid="service-landing-page-loading" className="bg-black min-h-screen" />;
  }

  return (
    <div data-testid="service-landing-page" className="bg-black min-h-screen">
      <div className="noise-overlay" />
      <Navbar logoUrl={content?.logo_url} brandName={brandName} />

      <PageHero eyebrow={seo.eyebrow} h1={seo.h1} image={resolveMediaUrl(seo.hero_image)} breadcrumbLabel={seo.eyebrow} />

      <section className="relative bg-black py-20 md:py-28 px-6 md:px-16">
        <div className="max-w-4xl space-y-20">
          <RevealSection>
            <p data-testid="page-intro" className="text-white/70 text-base md:text-lg leading-relaxed max-w-3xl">
              {seo.intro}
            </p>
          </RevealSection>

          <RevealSection delay={0.1}>
            <h2 data-testid="page-highlights-title" className="font-serif-display text-3xl md:text-4xl text-white mb-8">
              {seo.highlights_title}
            </h2>
            <HighlightsGrid items={seo.highlights} />
          </RevealSection>

          {seo.video_url && (
            <RevealSection delay={0.1}>
              <ServiceVideoSection videoUrl={seo.video_url} />
            </RevealSection>
          )}

          {seo.secondary_images?.length > 0 && (
            <RevealSection delay={0.1}>
              <SecondaryImagesGrid images={seo.secondary_images} />
            </RevealSection>
          )}

          <RevealSection delay={0.1}>
            <h2 data-testid="page-faq-title" className="font-serif-display text-3xl md:text-4xl text-white mb-4">
              {seo.faq_title}
            </h2>
            <FAQSection items={seo.faq} />
          </RevealSection>

          <RevealSection delay={0.1}>
            <PageCTA
              whatsappNumber={content?.whatsapp_number}
              whatsappMessage={page.whatsappMessage}
              ctaCategory={page.ctaCategory}
              quoteButtonText={seo.quote_button_text}
              whatsappButtonText={seo.whatsapp_button_text}
            />
          </RevealSection>

          <RevealSection delay={0.1}>
            <h2 className="font-serif-display text-2xl md:text-3xl text-white mb-6">Servicios relacionados</h2>
            <RelatedLinks items={page.related} />
          </RevealSection>
        </div>
      </section>

      <Footer brandName={brandName} logoUrl={content?.logo_url} />
      <WhatsAppFloat number={content?.whatsapp_number} />
    </div>
  );
};
